import { input } from '@angular/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-graphics',
  templateUrl: './graphics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphicsComponent {
  readonly graphic = input<'hexagon' | 'rond' | 'cel' | 'stippen'>();
}
